import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import { EWarrantGridRowData, EWarrantMenuActions } from 'data/eWarrant/eWarrant.types';
import './e-warrant-list-menu.scss';

type Props = {
  selectedEWarrant?: EWarrantGridRowData
  hasPrivilegeToView: boolean
  onView: () => void
};

/**
 * Actions shown on top of the grid once an e-warrant row is selected. Nothing is
 * rendered while the grid has no selection.
 *
 * Deciding on an e-warrant and generating its warrant are offered on the view page
 * only — both need the detail read (documents, services, targets) that the list does
 * not carry, so they are not driven from a selected row here.
 */
const EWarrantListMenu: FunctionComponent<Props> = ({
  selectedEWarrant,
  hasPrivilegeToView,
  onView,
}: Props) => {
  const { t } = useTranslation();

  if (selectedEWarrant == null) {
    return null;
  }

  return (
    <div data-testid="EWarrantListMenu" className="e-warrant-list-menu">
      {hasPrivilegeToView && (
        <Button
          className="e-warrant-list-menu-button"
          data-testid={`${EWarrantMenuActions.View}-button`}
          text={t('eWarrant.grid.view')}
          onClick={onView}
        />
      )}
    </div>
  );
};

export default EWarrantListMenu;
